// import React, { useState, useEffect } from "react";
// import { Form } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import Select from "react-select";
// import "./Contact_Section.css";
// import Success_Modal from "../../success-modal/Success_Modal";

// import { useDispatch, useSelector } from "react-redux";
// import { useForm, Controller } from "react-hook-form";
// import {
//   CreateContact_Us,
//   resetContactState,
// } from "../../../features/admin/contactus/call_contactus/Slice";

// import { AllQualification } from "../../../features/admin/common/Slice";

// const Contact_Section = ({}) => {
//   const [qualification, setQualification] = useState(null);
//   const options = [
//     { value: "10th", label: "10th Pass" },
//     { value: "12th", label: "12th Pass" },
//     { value: "graduate", label: "Graduate" },
//     { value: "postgraduate", label: "Post Graduate" },
//   ];
//   const side1 = [
//     {
//       icon: "/assets/images/home/Contact_Section/icon-1.png",
//       title: "Course & Curriculum Details",
//     },
//     {
//       icon: "/assets/images/home/Contact_Section/icon-2.png",
//       title: "Affordable Learning",
//     },

//     {
//       icon: "/assets/images/home/Contact_Section/icon-3.png",
//       title: "Career Guidance",
//     },

//     {
//       icon: "/assets/images/home/Contact_Section/icon-4.png",
//       title: "General Communications",
//     },
//   ];

//   const side2 = [
//     {
//       icon: "/assets/images/home/Contact_Section/icon-5.png",
//       title: "Flexible Learning Options",
//     },
//     {
//       icon: "/assets/images/home/Contact_Section/icon-6.png",
//       title: "Enrollment Process",
//     },
//     {
//       icon: "/assets/images/home/Contact_Section/icon-7.png",
//       title: "Internship Opportunities",
//     },
//     {
//       icon: "/assets/images/home/Contact_Section/icon-8.png",
//       title: "Certification Benefits",
//     },
//   ];

//   const [showModal, setShowModal] = useState(false);
//   const navigate = useNavigate();
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setShowModal(true); // open success modal

//     // close modal after 3 seconds
//     setTimeout(() => {
//       setShowModal(false);
//       navigate("/");
//     }, 3000);
//   };

//   const handleClose = () => {
//     setShowModal(false);
//     navigate("/");
//   };
//   return (
//     <section className="Contact_Section">
//       <div className="Contact_Section_header">
//         <h5 className="Contact_title">
//           Contact <span>Us</span>{" "}
//         </h5>

//         <span>
//           <img
//             src="/assets/images/home/Contact_Section/title-img.png"
//             alt="contact-img"
//             className="title_img"
//           />
//         </span>
//       </div>

//       <div className="contact_banner_div">
//         <div className="container">
//           <h5 className="banner_title">GET A CALL BACK</h5>

//           <div className="banner_content_holder">
//             <div className="row align-items-center justify-content-center">
//               <div className="col-lg-7 col-md-7">
//                 <div className="row">
//                   <div className="col-lg-6 col-md-6 col-sm-6 col-6">
//                     {side1.map((item, index) => (
//                       <div className="contact_item" key={index}>
//                         <img
//                           src={item.icon}
//                           alt={item.title}
//                           className="icon_img"
//                         />
//                         <p>{item.title}</p>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="col-lg-6 col-md-6 col-sm-6 col-6">
//                     {side2.map((item, index) => (
//                       <div className="contact_item" key={index}>
//                         <img src={item.icon} alt={item.title} />
//                         <p>{item.title}</p>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               <div className="col-lg-4 col-md-5">
//                 <div className="right_col_div">
//                   <div className="right_form_holder">
//                     <Form className="contact_form" onSubmit={handleSubmit}>
//                       <Form.Control
//                         type="text"
//                         placeholder="Full Name"
//                         className="custom_input mb-3"
//                       />
//                       <Form.Control
//                         type="email"
//                         placeholder="Email Address"
//                         className="custom_input mb-3"
//                       />

//                       <Form.Control
//                         type="text"
//                         placeholder="Phone Number"
//                         className="custom_input mb-3"
//                       />
//                       <Select
//                         options={options}
//                         value={qualification}
//                         onChange={setQualification}
//                         placeholder="Choose Qualification"
//                         className="custom_select"
//                         classNamePrefix="custom_select"
//                       />

//                       <div className="submit_btn_holder">
//                         <button className="submit_btn" type="submit">
//                           Submit Now
//                         </button>
//                       </div>
//                     </Form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Success_Modal text_msg="Form Successfull" show={showModal} />
//     </section>
//   );
// };

// export default Contact_Section;
import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import "./Contact_Section.css";
import Success_Modal from "../../success-modal/Success_Modal";

import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { CreateContact_Us } from "../../../features/admin/contactus/call_contactus/Slice";
import { AllQualification } from "../../../features/admin/common/Slice";

const Contact_Section = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const commonState = useSelector((state) => state.common || {});
  const { all_qualification = [] } = commonState;
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const options = [
  //   { value: "10th", label: "10th Pass" },
  //   { value: "12th", label: "12th Pass" },
  //   { value: "graduate", label: "Graduate" },
  //   { value: "postgraduate", label: "Post Graduate" },
  // ];

  useEffect(() => {
    dispatch(AllQualification());
  }, [dispatch]);

  const options =
    all_qualification?.map((qualification) => ({
      value:
        qualification.id ||
        qualification.qualification_id ||
        qualification.qualificationId,
      label:
        qualification.name ||
        qualification.qualification_name ||
        qualification.qualificationName ||
        qualification.title,
    })) || [];

  const side1 = [
    {
      icon: "/assets/images/home/Contact_Section/icon-1.png",
      title: "Course & Curriculum Details",
    },
    {
      icon: "/assets/images/home/Contact_Section/icon-2.png",
      title: "Affordable Learning",
    },
    {
      icon: "/assets/images/home/Contact_Section/icon-3.png",
      title: "Career Guidance",
    },
    {
      icon: "/assets/images/home/Contact_Section/icon-4.png",
      title: "General Communications",
    },
  ];

  const side2 = [
    {
      icon: "/assets/images/home/Contact_Section/icon-5.png",
      title: "Flexible Learning Options",
    },
    {
      icon: "/assets/images/home/Contact_Section/icon-6.png",
      title: "Enrollment Process",
    },
    {
      icon: "/assets/images/home/Contact_Section/icon-7.png",
      title: "Internship Opportunities",
    },
    {
      icon: "/assets/images/home/Contact_Section/icon-8.png",
      title: "Certification Benefits",
    },
  ];

  const onSubmit = async (data) => {
    console.log("Contact Section Form Data:", data);

    try {
      setIsSubmitting(true);
      const res = await dispatch(CreateContact_Us(data)).unwrap();

      console.log("API Response:", res);

      if (res?.success) {
        setShowModal(true);
        reset();

        setTimeout(() => {
          setShowModal(false);
          navigate("/");
        }, 3000);
      }
    } catch (error) {
      console.error("Contact form error:", error);
      alert(`Error: ${error || "Something went wrong"}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    reset();
  };

  return (
    <section className="Contact_Section">
      <div className="Contact_Section_header">
        <h5 className="Contact_title">
          Contact <span>Us</span>{" "}
        </h5>

        <span>
          <img
            src="/assets/images/home/Contact_Section/title-img.png"
            alt="contact-img"
            className="title_img"
          />
        </span>
      </div>

      <div className="contact_banner_div">
        <div className="container">
          <h5 className="banner_title">GET A CALL BACK</h5>

          <div className="banner_content_holder">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-7 col-md-7">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    {side1.map((item, index) => (
                      <div className="contact_item" key={index}>
                        <img
                          src={item.icon}
                          alt={item.title}
                          className="icon_img"
                        />
                        <p>{item.title}</p>
                      </div>
                    ))}
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    {side2.map((item, index) => (
                      <div className="contact_item" key={index}>
                        <img src={item.icon} alt={item.title} />
                        <p>{item.title}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-5">
                <div className="right_col_div">
                  <div className="right_form_holder">
                    <Form
                      className="contact_form"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Full Name"
                          className="custom_input"
                          {...register("name", {
                            required: "Name is required",
                            minLength: {
                              value: 3,
                              message: "Name must be at least 3 characters",
                            },
                            maxLength: {
                              value: 50,
                              message: "Name cannot exceed 50 characters",
                            },
                            pattern: {
                        value: /^[A-Za-z]+(\s[A-Za-z]+)*$/,
                        message:
                          "Name should contain only letters and single spaces",
                      },
                    })}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      e.target.value = value;

                      register("name").onChange(e);
                    }}
                  />
                        {errors.name && (
                          <small className="text-danger d-block mt-1">
                            {errors.name.message}
                          </small>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Control
                          type="email"
                          placeholder="Email Address"
                          className="custom_input"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(?:[A-Za-z]{2,})$/,
                              message: "Enter a valid email address",
                            },
                          })}
                        />
                        {errors.email && (
                          <small className="text-danger d-block mt-1">
                            {errors.email.message}
                          </small>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Enter your number"
                          className="custom_input"
                          maxLength={10}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              "",
                            );
                          }}
                          {...register("mobile_number", {
                            required: "Mobile number is required",
                            pattern: {
                              value: /^[0-9]{10}$/,
                              message:
                                "Mobile number must be exactly 10 digits",
                            },
                          })}
                        />
                        {errors.mobile_number && (
                          <small className="text-danger d-block mt-1">
                            {errors.mobile_number.message}
                          </small>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Controller
                          name="qualification_id"
                          control={control}
                          rules={{ required: "Qualification is required" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={options}
                              placeholder="Choose Qualification"
                              className="custom_select"
                              classNamePrefix="custom_select"
                              value={
                                options.find(
                                  (opt) => opt.value === field.value,
                                ) || null
                              }
                              onChange={(option) =>
                                field.onChange(option?.value || "")
                              }
                            />
                          )}
                        />
                        {errors.qualification_id && (
                          <small className="text-danger d-block mt-1">
                            {errors.qualification_id.message}
                          </small>
                        )}
                      </Form.Group>

                      <div className="submit_btn_holder">
                        <button
                          className="submit_btn"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Submit Now"}
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Success_Modal text_msg="Form Successfull" show={showModal} handleClose={handleClose} />
    </section>
  );
};

export default Contact_Section;
